import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/cursor.tsx
var Cursor = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M3.45158 4.72816L9.06387 20.5555C9.36964 21.4178 10.577 21.4507 10.9293 20.6063L13.6196 14.1574C13.721 13.9142 13.9143 13.7209 14.1575 13.6194L20.6064 10.9292C21.4508 10.5769 21.4179 9.36952 20.5556 9.06375L4.72828 3.45145C3.93501 3.17016 3.17029 3.93489 3.45158 4.72816Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M4.97896 2.74473C3.59074 2.25247 2.25247 3.59074 2.74473 4.97896L8.35702 20.8063C8.89212 22.3153 11.005 22.3729 11.6215 20.8952L14.3118 14.4463C14.3371 14.3855 14.3855 14.3371 14.4463 14.3118L20.8952 11.6215C22.3729 11.005 22.3153 8.89213 20.8063 8.35702L4.97896 2.74473Z",
		fill: "currentColor"
	})
});
//#endregion
export { Cursor };
